function getJsonUrl(){
    return "/content/json/";

}

export async function loadDataVehicles() {
    try {
        const response = await fetch(getJsonUrl() + "vehicles.json");
        return await response.json();
    } catch (error) {
        console.error('Error fetching JSON:', error);
        return false;
    }
}

export async function loadRegionData() {
    try {
        const response = await fetch(getJsonUrl() + "regions.json");
        return await response.json();
    } catch (error) {
        console.error('Error fetching JSON:', error);
        return false;
    }
}
export async function loadRibbonColours() {
    const ribbonData = {};

    const keyMap = {
        savings: 'vehicle-landing-page.ribbon-color-savings',
        savingsHighlight: 'vehicle-landing-page.ribbon-color-savings-highlight',
        express: 'vehicle-landing-page.ribbon-color-express',
        expressHighlight: 'vehicle-landing-page.ribbon-color-express-highlight',
        expressText: 'vehicle-landing-page.ribbon-text-express'
    };

    await Promise.all(Object.entries(keyMap).map(async ([shortKey, fullKey]) => {
        const response = await fetch(`/api/v1/getOptions/${encodeURIComponent(fullKey)}`);
        const value = await response.text();
        ribbonData[shortKey] = value;
    }));

    return ribbonData;
}
